import { render, staticRenderFns } from "./veStuHealthAskShow.vue?vue&type=template&id=7ae9db18&scoped=true"
import script from "./veStuHealthAskShow.vue?vue&type=script&lang=js"
export * from "./veStuHealthAskShow.vue?vue&type=script&lang=js"
import style0 from "./veStuHealthAskShow.vue?vue&type=style&index=0&id=7ae9db18&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae9db18",
  null
  
)

export default component.exports